import { createModel } from '@rematch/core';
import apiConnector from '../../api/ApiConnector';
import { IFilterPart, IFromToDatePart, IPayloadExpertExams } from 'components/models';
import { IExamList } from '../../api/ApiClient';

const initialState: State = {
    expertExamsList: null,
};

export default createModel({
    state: initialState,
    reducers: {
        setExamsList(state, expertExamsList: IExamList): State {
            return { ...state, expertExamsList };
        },
    },
    effects: (dispatch: any) => ({
        async getExamsListAsync(
          {
              expertId, page, pageSize, sortOrder, sortField, from, to, filteredExamStatus,
              qualificationIds, attestationSubCommissionIds, accreditationCenterIds,
          }: IPayloadExpertExams & IFilterPart & IFromToDatePart,
        ) {
            const examsList = await apiConnector.execApi(dispatch, apiClient => apiClient.getExpertExams(
              expertId,
              qualificationIds,
              attestationSubCommissionIds,
              accreditationCenterIds,
              filteredExamStatus,
              from,
              to,
              page,
              pageSize,
              sortOrder,
              sortField,
            ));

            this.setExamsList(examsList);
        },
    }),
});

interface State {
    expertExamsList: IExamList | null;
}
